var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clientType
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [
          _vm.isMobile(_vm.$mq)
            ? _c("AppMobile", {
                attrs: { "should-hide-header": _vm.shouldHideHeader },
                on: { mounted: _vm.checkHash }
              })
            : _c("AppDesktop", {
                attrs: { "should-hide-header": _vm.shouldHideHeader },
                on: { mounted: _vm.checkHash }
              }),
          _vm._v(" "),
          _vm.errorModalIsVisible ? _c("ErrorModal") : _vm._e()
        ],
        1
      )
    : _c(
        "span",
        { staticClass: "app-loading" },
        [
          _c("LoadingAnimation", { staticClass: "app-spinner" }),
          _vm._v(" "),
          _vm.errorModalIsVisible ? _c("ErrorModal") : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }